export const storeFavoriteMarkerSvgRevamp = `
<svg width="51" height="54" viewBox="0 0 51 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 4.5c-8.5 0-15.3 6.9-15.3 15.3C9.7 31.3 25 48.2 25 48.2s15.3-17 15.3-28.4c0-8.4-6.9-15.3-15.3-15.3Z"
        fill="#502314" />
    <path
        d="m25 28.6-1.3-1.1c-4.5-4-7.5-6.5-7.5-9.7 0-2.5 2.1-4.5 4.8-4.5 1.6 0 3 .6 4 1.7 1-1 2.4-1.7 3.9-1.7 2.7 0 4.8 2 4.8 4.5 0 3.2-3 5.8-7.5 9.7l-1.2 1Z"
        fill="#fff" />
</svg>
`;
